import { render } from "./LoginBanner.vue?vue&type=template&id=0a6a53a6&scoped=true"
const script = {}

import "./LoginBanner.vue?vue&type=style&index=0&id=0a6a53a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6a53a6"]])

export default __exports__